var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSettings = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 172.64 176.25"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Settings_svg__cls-1{fill:none;stroke:currentColor;stroke-linecap:square;stroke-miterlimit:10;stroke-width:11.25px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Settings_svg__Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Settings_svg___\\xCE\\xD3\\xC8_1",
  "data-name": "\\u2014\\xCE\\xD3\\xC8_1"
}, /*#__PURE__*/React.createElement("circle", {
  className: "Settings_svg__cls-1",
  cx: 86.32,
  cy: 88.13,
  r: 22.5
}), /*#__PURE__*/React.createElement("path", {
  className: "Settings_svg__cls-1",
  d: "M86.32 5.62h-15l-2.94 25.23A60 60 0 0 0 45.7 44L22.38 33.89l-15 26L27.75 75a60.47 60.47 0 0 0 0 26.19l-20.37 15.2 15 26 23.32-10.1a60 60 0 0 0 22.68 13.11l2.94 25.22h15M86.32 170.62h15l2.94-25.22a59.89 59.89 0 0 0 22.68-13.11l23.33 10.07 15-26-20.38-15.17a60.67 60.67 0 0 0 0-26.19l20.38-15.17-15-26L126.94 44a59.89 59.89 0 0 0-22.68-13.11l-2.94-25.27h-15"
})))));
export default SvgSettings;